import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface HeaderCloseButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const HeaderCloseButtonComponent: React.FC<HeaderCloseButtonProps> = ({
  onClick,
  disabled,
  style,
  children,
}) => {
  return (
    <button
      className="peptalk-chat-close-button"
      onClick={onClick}
      aria-label="Close chat"
      type="button"
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
};

export const HeaderCloseButton: React.FC<HeaderCloseButtonProps> = (
  props: HeaderCloseButtonProps
) => {
  const Component = useCustomComponent({
    componentName: 'HeaderCloseButton',
    Component: HeaderCloseButtonComponent,
  });
  return <Component {...props} />;
};
